import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { AppShell } from './components/AppShell';
import { AccountPage } from './routes/account/AccountPage';
import { LoginPage } from './routes/account/LoginPage';
import { ForgotPasswordPage, ResetPasswordPage } from './routes/account/PasswordPages';
import { SignupPage } from './routes/account/SignupPage';
import { ComingSoonPage } from './routes/ComingSoonPage';
import { HomePage } from './routes/HomePage';

const rootRoute = createRootRoute({
  component: AppShell,
  notFoundComponent: () => <ComingSoonPage title="Página no encontrada" />,
});

const sections = [
  { path: '/playground', title: 'Playground' },
  { path: '/historial', title: 'Historial' },
  { path: '/asistentes', title: 'Asistentes' },
  { path: '/biblioteca', title: 'Biblioteca' },
];

const pages = [
  { path: '/cuenta', component: AccountPage },
  { path: '/entrar', component: LoginPage },
  { path: '/registro', component: SignupPage },
  { path: '/recuperar', component: ForgotPasswordPage },
  { path: '/restablecer-contrasena', component: ResetPasswordPage },
];

const routeTree = rootRoute.addChildren([
  createRoute({ getParentRoute: () => rootRoute, path: '/', component: HomePage }),
  ...sections.map(({ path, title }) =>
    createRoute({
      getParentRoute: () => rootRoute,
      path,
      component: () => <ComingSoonPage title={title} />,
    }),
  ),
  ...pages.map(({ path, component }) =>
    createRoute({ getParentRoute: () => rootRoute, path, component }),
  ),
]);

export function createAppRouter() {
  return createRouter({ routeTree });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
